import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Tooltip } from 'antd';
import { isMobile } from '../../../utils/detectDevice';

function getDrawerBodyWidth() {
  try {
    const drawerBody = document?.querySelector('.ant-drawer-body');
    let width = 500;
    if (drawerBody) {
      width = drawerBody.getBoundingClientRect().width;
    }
    return width;
  } catch (err) {
    console.log(err);
  }
}

export function IconTitle(props) {
  const { iconName, icon, title } = props;

  function renderIcon() {
    if (typeof iconName === 'string') {
      return <i className={`icon ${iconName} icon-${iconName}`} />;
    }
    return icon;
  }

  function renderHeaderTooltip(text) {
    // To display tooltip when
    // Mobile: text length more than 20.
    // Desktop: text length more than 28.
    // NOTE: Decided the max length as 20 and 28 after tested on various devices
    const textLength = (text?.length > (isMobile ? 20 : 28));

    // To show ellipsis on map drawer
    const drawerWidth = getDrawerBodyWidth();
    const showEllipsis = (isMobile || (drawerWidth <= 400));
    return (
      <Tooltip
        title={textLength ? text : ''}
        trigger={showEllipsis ? 'click' : 'hover'}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
      >
        <div className={showEllipsis ?'sensor-header-ellipsis' : ''}>{text}</div>
      </Tooltip>
    );
  }

  return (
    <span className="icontitle-container">
      <Typography.Title className="flex-row align-center text-align-left" level={4}>
        {renderIcon()}
        {renderHeaderTooltip(title)}
      </Typography.Title>
    </span>
  );
}

IconTitle.defaultProps = {
  icon: null,
  iconName: null,
  title: '',
};

IconTitle.propTypes = {
  icon: PropTypes.node,
  iconName: PropTypes.string,
  title: PropTypes.string,
};
